<template>
  <div style="width: 100%; margin: 0 auto">
    <div class="body_top">
      <div class="bg_img_div">
        <!-- <img src="@/assets/newIndexBg1.png" /> -->
      </div>
      <!-- 绝对定位 -->
      <div class="body_top_abs">
        <div class="img_he">
          <img class="log_Img" :src="require('@/assets/herder_logo1.png')" alt="" />
        </div>
        <p class="bt1">为您提供一站式数字影像解决方案</p>
        <div class="body_top_abs_gn">
          <div class="ag_select">
            <span v-for="index in bottomList" :key="index" :class="index.checked == true ? 'ag_selectT cur' : 'ag_selectF cur'
              " @click="selectClick(index)">{{ index.title }}</span>
          </div>
          <div class="ag_l">
            <div class="ss_abs_c_srk">
              <input v-model="setTitle" :placeholder="placeholderTitle" @keyup.enter="clicklby" />
              <div class="cur" @click="clicklby">
                <img src="@/assets/yxsc_ss.png" />
                搜索
              </div>
            </div>
          </div>
          <div class="log_box">
            <!-- <img src="@/assets/log1.png" /> -->
            <!-- <p>x</p> -->
            <img src="@/assets/log2.png" />
            <!-- <p>x</p> -->
            <img src="@/assets/log3.png" />
          </div>
        </div>

        <!-- <p class="bt1">为您提供一站式数字影像解决方案</p>
        <p class="bt2">用正版，更放心</p>
        <div class="body_top_abs_gn">
          <div class="ag_select">
            <span
              v-for="index in bottomList"
              :key="index"
              :class="
                index.checked == true ? 'ag_selectT cur' : 'ag_selectF cur'
              "
              @click="selectClick(index)"
              >{{ index.title }}</span
            >
          </div>
          <div class="ag_l">
            <div class="ss_abs_c_srk">
              <input
                v-model="setTitle"
                :placeholder="placeholderTitle"
                @keyup.enter="clicklby"
              />
              <div class="cur" @click="clicklby">
                <img src="../../assets/yxsc_ss.png" />
                搜索
              </div>
            </div>
          </div>

        </div>
      -->
      </div>
    </div>
    <!-- <span class="ss_abs_c_center">或</span>
						<div @click="showReleaseLease" class="ss_abs_c_right">发布需求</div> -->

    <div class="body_main">
      <!-- 模块1 -->
      <!-- <div class="index_mk_body">
        <div>
          <img src="../../assets/index_mk1.png" />
          <div class="index_mk_right">
            <span>版权无忧</span>
            <div class="index_mk_right_div">
              <span>省内优质原创作人为您创作，版权保障后顾无忧</span>
            </div>
          </div>
        </div>
        <div>
          <img src="../../assets/index_mk2.png" />
          <div class="index_mk_right">
            <span>制作提效</span>
            <div class="index_mk_right_div">
              <span>全场景成品制作模板，支持换
                Logo、修改文字，让影视制作更简单、更智能</span>
            </div>
          </div>
        </div>
        <div>
          <img src="../../assets/index_mk3.png" />
          <div class="index_mk_right">
            <span>降本增效</span>
            <div class="index_mk_right_div">
              <span>找人，找素材，找业务，一站式完美解决</span>
            </div>
          </div>
        </div>
      </div> -->
      <el-alert type="warning" v-if="JSON.stringify(formationObj) != '{}'" title="" :show-icon="false" :closable="false">
        <div class="prompt" @click="initTo" style="cursor: pointer">
          <img style="width: 12px; height: 15px" src="@/assets/horn.png" />
          <!-- <el-icon><Plus /></el-icon> -->
          <span class="ml5">平台升级提示
            <span class="ml5" style="
                display: inline-block;
                padding-bottom: 2px;
                border-bottom: 1px solid;
                text-decoration: none;
              ">查看详情</span>
          </span>
        </div>
      </el-alert>
      <!-- <div class="prompt">
        <div class="prompt1">平台升级提示 查看详情</div>
      </div> -->
      <div class="index_mk_body1">
        <div>
          <!-- <p>版权无忧</p>
          <p>省内优质原创作人为您创作，版权保障后顾无忧</p> -->
        </div>
        <div>
          <!-- <p>制作提效</p>
          <p>全场景成品制作模板，支持换 Logo、修改文字，让影视制作更简单、更智能</p> -->
        </div>
        <div>
          <!-- <p>降本增效</p>
          <p>找人，找素材，找业务，一站式完美解决</p> -->
        </div>
      </div>
      <!-- 类型 -->
      <div class="index_typeList">
        <!-- <el-carousel height="150px">
          <el-carousel-item v-for="item in 4" :key="item">
          </el-carousel-item>
        </el-carousel> -->
        <el-carousel :interval="2000" :autoplay="true">
          <el-carousel-item v-for="item in images" :key="item.id" @click.native="linkTo(item)">
            <img style="width: 100%" :src="item.imagePath" />
            <!-- <h3 text="2xl" justify="center">{{ item }}</h3> -->
          </el-carousel-item>
        </el-carousel>
        <!-- <img src="../../assets/indexbanner1.png" /> -->
      </div>
      <!-- 作品  -->
      <!-- <div class="SL_classify">
				<dropDown :boxRef="topParams" @tabClick="handleTab"></dropDown>
				<div @click="allWorksClick('/ShadowIndexAllWorks')" class="SL_classify_body">
					查看全部 >
				</div>
			</div> -->

      <!-- <div class="SL_hotSongwriter_list">
				<div class="worksClassifyBody">
					 <div class="wCB_select"></div>
					<div class="SL_classify_body">
						<el-row :gutter="20">
							<el-col style="margin-top: 0.32rem" :span="6" v-for="(item, index) in list" :key="index">
								<moduleWorks :item="item" class="SL_CB_list" @click="ParticularsFun(item)"></moduleWorks>
							</el-col>
						</el-row>
					</div> 
				 <img class="zwsj" src="../../assets/zt_zanwushuju.png" />

				</div>
			</div> -->
      <!-- 热门创作人 -->
      <div class="SL_hotSongwriter" style="margin-bottom: 0">
        <div class="SL_hotSongwriter_title">热门创作人</div>
        <div @click="allWorksClick('/ShadowComposer')" class="SL_hotSongwriter_click">
          查看全部 >
        </div>
      </div>

      <div class="">
        <!-- <el-row :gutter="20">
					<el-col :span="6" v-for="(index) in 8" :key="index">
						<moduleHotComposer @click="goModuleHotComposer"></moduleHotComposer>
					</el-col>
				</el-row> -->
        <el-row>
          <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6" v-for="index in userList" :key="index"
            @click="composer(index)">
            <moduleHotComposer class="cur" :message="index"></moduleHotComposer>
          </el-col>
        </el-row>
        <!-- <img class="zwsj" src="../../assets/zt_zanwushuju.png" /> -->
      </div>
      <!-- 提供素材 -->
      <div class="SL_hotSongwriter">
        <div class="SL_hotSongwriter_title">推荐素材</div>
        <div class="SL_hotSongwriter_click" @click="allWorksClick('/ShadowMaterial')">
          查看全部 >
        </div>
      </div>
      <div>
        <el-row>
          <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6" v-for="index in musicList" :key="index">
            <moduleProvideMaterial :collectIds="collectIds" :message="index" class="SL_offerMaterialListdiv cur">
            </moduleProvideMaterial>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
					<el-col :span="6" v-for="(index) in 8" :key="index">
						<moduleProvideMaterial @click="goModuleProvideMaterial" class="SL_offerMaterialListdiv">
						</moduleProvideMaterial>
					</el-col>
				</el-row> -->
        <!-- <img class="zwsj" src="../../assets/zt_zanwushuju.png" /> -->
      </div>

      <!-- 最新需求 -->
      <div class="SL_hotSongwriter">
        <div class="SL_hotSongwriter_title">最新需求</div>
        <div @click="go_xq" class="SL_hotSongwriter_click cur">查看全部 ></div>
      </div>
      <div class="SL_newNeed">
        <moduleNewNeed class="SL_newNeeddiv cur" v-for="index in xqList" @click="goModuleNewNeed(index)" :key="index"
          :item="index">
        </moduleNewNeed>
      </div>
      <!-- <ShadowIndexWParticulars @openClickA="openClickA" @openClickOverClose="openClickOverClose"
				@openClickOverOpen="openClickOverOpen" v-if="Particulars"
				:style="ParticularsOverflowY == false ? 'overflow-y: auto;' : 'overflow-y: clip;'" class="Particulars">
			</ShadowIndexWParticulars> -->
      <!-- 作品播放 -->
      <ShadowIndexWParticulars @openShowInfo="openShowinfo" @openClickA="openClickA"
        @openClickOverClose="openClickOverClose" :workId="workID" @openClickOverOpen="openClickOverOpen"
        v-if="Particulars" :style="ParticularsOverflowY == false
          ? 'overflow-y: auto;'
          : 'overflow-y: clip;'
          " class="Particulars">
      </ShadowIndexWParticulars>
    </div>
    <el-dialog v-model="show" align-center width="480px" :close-on-click-modal="false" title="系统通知">
      <div style="text-align: center">
        {{ showTitle ? showTitle : "系统通知" }}
      </div>
      <div v-html="showHtml" style="text-align: center; padding-top: 5px; font-size: 14px"></div>
      <!-- <div style="display: flex; justify-content: center">
      <div class="dataBtnClose" @click="show = false">取消</div>
      <div class="dataBtnSubmit" @click="show = false">确认</div>
    </div> -->
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import moduleWorks from "../../components/moduleWorks.vue";
import moduleNewNeed from "../../components/moduleNewNeed.vue";
import moduleProvideMaterial from "../../components/moduleProvideMaterial.vue";
import moduleHotComposer from "../../components/moduleHotComposer.vue";
import ShadowIndexWParticulars from "../../components/ShadowIndexWParticulars.vue";
import dropDown from "../../components/comTemplate/drop-down.vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
document.title = "标识山西-首页";
let show = ref(false);
let showHtml = ref("<p></p>");
let showTitle = ref(null);
const store = useStore();
const router = useRouter();
const searchValue = ref("");
const carousel = ref(null);
const meaasgeTitle_list_xttz = computed(() => {
  // console.info(store.state.uploadList);
  return store.state.SystemMessages.filter((e) => e.code == "system_notice");
});
const searchClick = function () {
  alert("出发回车键事件-获取参数" + searchValue.value);
};
const slideshowList = ref([
  {
    img: require("../../assets/LS2.png"),
  },
  {
    img: require("../../assets/LS2.png"),
  },
  {
    img: require("../../assets/LS2.png"),
  },
  {
    img: require("../../assets/LS2.png"),
  },
  {
    img: require("../../assets/LS2.png"),
  },
]);
const allWorksClick = function (index) {
  router.push({
    path: index,
    query: { type: index == "/ShadowMaterial" ? "video" : "" },
  });
};
const bodyStyle = document.body.style;
const Particulars = ref(false);
const ParticularsOverflowY = ref(false);
const ParticularsFun = function (item) {
  // console.log(111)
  workID.value = item.id;
  Particulars.value = true;
  bodyStyle.overflowY = "hidden";
};
const openClickA = function () {
  Particulars.value = false;
  bodyStyle.overflowY = "clip";
};
const openClickOverClose = function () {
  ParticularsOverflowY.value = true; // 关闭
};
const openClickOverOpen = function () {
  ParticularsOverflowY.value = false; // 打来
};
const goModuleHotComposer = function (item) {
  router.push({
    path: "/ShadowBusinessParticulars",
    query: {
      id: item.id,
    },
  });
};
const goModuleProvideMaterial = function () {
  router.push({
    path: "/ShadowMaterialVideoParticulars",
  });
};
const goModuleNewNeed = function (item) {
  router.push({
    path: "/ShadowBusinessParticulars",
    query: {
      id: item.id,
    },
  });
};
const bottomList = ref([
  {
    title: "搜视频",
    checked: true,
    url: "/ShadowMaterialVideoList",
    params: { type: "VIDEO" },
    title2: "输入视频名称等进行搜索",
  },
  {
    title: "搜音乐",
    checked: false,
    url: "/ShadowMaterialVideoList",
    params: { type: "MUSIC" },
    title2: "输入音乐类型,名称等进行搜索",
  },
  {
    title: "搜图片",
    checked: false,
    url: "/ShadowMaterialVideoList",
    params: { type: "IMAGE" },
    title2: "输入图片类型,名称等进行搜索",
  },
  {
    title: "搜服务",
    checked: false,
    url: "/ShadowBusinessList",
    title2: "输入服务进行搜索",
  },
  {
    title: "搜人才",
    checked: false,
    url: "/ShadowComposer",
    title2: "输入人才进行搜索",
  },
  // {
  // 	title: '搜作品',
  // 	checked: false
  // }
]);
const placeholderTitle = ref(bottomList.value[0].title2);

const selectClick = function (index) {
  for (let i = 0; i < bottomList.value.length; i++) {
    if (bottomList.value[i] == index) {
      bottomList.value[i].checked = true;
      placeholderTitle.value = bottomList.value[i].title2;
    } else {
      bottomList.value[i].checked = false;
    }
  }
};

/*
  作品开始
*/
let workID = ref("");

const type = ref(0);
const list = ref([]);
let from = ref({
  condition: {
    recommendType: 1, // 1首页推荐 2编辑推荐 , 3葡萄推荐
    category1_id: null, // 	类目ID
    categoryId: null, // 	类目ID

    videoDefinition: null,
    // publish_mode: 2,  不需要
  },
  keyWord: "",
  startTime: null,
  endTime: null,
  pageIndex: 1,
  pageSize: 12,
  // sort: "id",
  //  sort: 'likes',
  total: 0,
});
// 作品首页分类
const topParams = ref({
  left: [
    {
      name: "首页推荐",
      value: "1",
      listShow: true,
      list: [
        {
          name: "首页推荐",
          value: "1",
        },
        {
          name: "编辑推荐",
          value: "2",
        },
        {
          name: "普通推荐",
          value: "3",
        },
      ],
    },
    {
      name: "最新作品",
      value: "2",
      listShow: false,
    },
    {
      name: "我的关注",
      value: "3",
      listShow: false,
    },
  ],
});
// 作品首页分类返回事件
const handleTab = function (...data) {
  // console.log(
  // 	"🚀 ~ file: ShadowIndexAllWorks.vue:311 ~ handleTab ~ data:",
  // 	data
  // );
  // console.log(3333333333333333)
  const params = JSON.parse(JSON.stringify(topParams.value));
  if (data[0] == "1") {
    if (data[3].name) {
      params.left[0].name = data[3].name;
      from.value.condition.recommendType = data[3].value;
      // from.value.sort = "id";
    } else {
      from.value.condition.recommendType = "1";
    }
    getlist();
  } else if (data[0] == "2") {
    // console.log(3333333333333333)
    delete from.value.condition.recommendType;
    getlist(true);
  } else if (data[0] == "3") {
    delete from.value.condition.recommendType;
    getFlowerlist();
  } else if (data[0] == "4") {
    if (data[3].name) {
      params.right[0].name = data[3].name;
      if (data[1]) {
        var times = data[1].split("-");
        from.value.startTime = times[0];
        from.value.endTime = times[1];
      } else {
        from.value.startTime = null;
        from.value.endTime = null;
      }
    }
    if (type.value > 0) {
      getFlowerlist();
    } else {
      getlist();
    }
  } else if (data[0] == "5") {
    if (data[3].name) {
      params.right[1].name = data[3].name;
      from.value.condition.videoDefinition = data[1];
    } else {
      from.value.condition.videoDefinition = null;
    }
    if (type.value > 0) {
      getFlowerlist();
    } else {
      getlist();
    }
  }
  // console.log(3333333333333333)
  /*

  */
  topParams.value = params;
};
// 作品首页请求
const getlist = function (e) {
  let obj = { ...from.value };
  let obj1 = { ...from.value.condition };

  for (let key in obj) {
    if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }
  for (let key in obj1) {
    if (obj1[key] === "" || obj1[key] === null || obj1[key] === undefined) {
      delete obj1[key];
    }
  }
  obj.condition = obj1;
  if (e) {
    type.value = 0;
  }
  Axios("POST", "/material/material/work/list", obj, null, function (res) {
    list.value = res.data.data.records;
    from.value.total = res.data.data.total;
  });
};
// 作品关注列表
const getFlowerlist = function () {
  let obj = { ...from.value };
  let obj1 = { ...from.value.condition };

  for (let key in obj) {
    if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }
  for (let key in obj1) {
    if (obj1[key] === "" || obj1[key] === null || obj1[key] === undefined) {
      delete obj1[key];
    }
  }
  obj.condition = obj1;
  type.value++;
  Axios(
    "POST",
    "/material/material/work/flowerList",
    obj,
    null,
    function (res) {
      res.data.data ? (list.value = res.data.data.records) : (list.value = []);
    }
  );
};
// 作品弹窗事件
const openShowinfo = function (id) {
  Particulars.value = false;
  workID.value = id;
  bodyStyle.overflowY = "hidden";
  setTimeout(() => {
    Particulars.value = true;
  }, 50);
};
getlist();
/*
  作品结束
*/
/**
 * 创作人开始
 */

let userList = ref();
let memberType = ref("ENTERPRISE"); // 分类传参
let getuserList = function () {
  // 获取 创作者列表
  let params = {
    // realStatus: 2, // 实名认证 2 成功 固定传参
    // memberType: memberType.value != "" ? memberType.value : null, // 类型
    memberTypeld: "", // 条件查询
    pageSize: 8,
  };
  Axios("GET", "/member/front/index", params, false, function (res) {
    userList.value = res.data.rows;
  });
};
const composer = function (index) {
  // console.log(index.memberId);
  router.push({
    path: "/ShadowComposerHomepage",
    query: { id: index.memberId },
  });
};
getuserList();

/**
 * 创作人结束
 */

/**
 * 素材视频开始
 */
const musicList = ref([]);
const getMusicData = function () {
  let params = {
    materialType: "VIDEO", // 类型
    // memberId: null, // 会员id
    status: 1, // 审核状态
    // pageIndex: 1,
    // pageSize: 20
  };
  Axios("get", "/fodder/front/index", params, false, function (res) {
    musicList.value = [];
    musicList.value = res.data.data;
  });
};
getMusicData();

/**
 * 素材视频结束
 */
// 自定义请求封装

// import comapi from '/src/comapi/api.js';
// let params = {}
// comapi.post('/material/course/list', params)
// 	.then(response => {
// 		console.log(response);
// 	})
// 	.catch(error => {
// 		console.error(error);
// 	});
const xqList = ref();
const from1 = ref({
  keyWord: "",
  pageIndex: 1,
  pageSize: 5,
  condition: {
    type: 1,
    isHomePage: 1,
  },
  total: 0,
});
const getxqList = function () {
  Axios(
    "POST",
    "/material/material/need/list",
    from1.value,
    false,
    function (res) {
      if (res.data.code == 200) {
        // from1
        xqList.value = res.data.data.records;
      } else {
        ElMessage.error(res.data.message);
      }
    }
  );
};
let formationObj = ref({});
const getinformation = function () {
  Axios("get", "/system/notice/system-list", null, false, function (res) {
    if (res.data.code == 200) {
      // console.log(res.data.data);
      res.data.data.length ? (formationObj.value = res.data.data[0]) : "";
      console.log(formationObj.value);
      JSON.stringify;
    } else {
      ElMessage.error(res.data.message);
    }
  });
};
getinformation();

const initTo = function () {
  // console.log(meaasgeTitle_list_xttz.value);
  showTitle.value = formationObj.value.noticeTitle;
  showHtml.value = formationObj.value.noticeContent;
  show.value = true;
};
getxqList();
// 搜索
let setTitle = ref(""); //搜索内容
const clicklby = function () {
  if (setTitle.value == "") {
    ElMessage({
      message: "搜索不可为空",
      type: "error",
    });
  } else {
    let params = {};

    for (let i = 0; i < bottomList.value.length; i++) {
      if (bottomList.value[i].checked == true) {
        if (bottomList.value[i].params) {
          params["materialType"] = bottomList.value[i].params.type;
        }
        params["inputTitle"] = setTitle.value;
        console.log(bottomList.value[i].url);
        // ShadowMaterialVideoList?type=music&inputTitle=1
        // ShadowMaterialVideoList?materialType=VIDEO

        router.push({
          path: bottomList.value[i].url,
          query: params,
        });
      }
    }
  }
};
// 跳转需求列表页面
const go_xq = function () {
  router.push({
    path: "/ShadowBusiness",
  });
};
const images = ref([]);
const getAdvert = function () {
  Axios("POST", "/system/advert/index", {}, false, function (res) {
    if (res.data.code == 200) {
      // from1
      images.value = res.data.data;
    }
  });
};
getAdvert();
const linkTo = function (item) {
  // if (localStorage.getItem("token") == null) {
  //   window.open('/TgLogin', "_self");
  //   return
  // }
  let link = item.id == 14 && item.linkUrl.indexOf('?') != -1 ? item.linkUrl + '&s=c' : item.linkUrl;
  if (link.indexOf("https") != -1 || link.indexOf("http") != -1) {
    window.open(link, "_target");
  }
  else {
    router.push({
      path: link,
    });
  }

};
const collectIds = ref([])
const getCollects = async () => {
  await Axios(
    "get",
    "/fodder/collect/collect-ids",
    {
    },
    false,
    (res) => {
      collectIds.value = res.data.data
    }
  );
}
getCollects();
</script>
<!-- 

 -->
<style lang="less" scoped>
/deep/ .el-carousel__item {
  background: transparent !important;
}

.zwsj {
  width: 4rem;
  display: block;
  margin: 0 auto;
}

.SL_input {
  background: #f2f3f5;
  width: 100%;
  padding: 0.15rem;
  color: #86909c;
  font-size: 0.13rem;
  border: 0px solid #fff;
  display: block;
  border-radius: 0.08rem;
  margin: 0 auto;
}

.index_mk_right_div>span {
  font-size: 0.14rem;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.index_typeList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.4rem;
}

/deep/ .el-carousel__container {
  height: 281px;
  border-radius: 0.12rem;
  overflow: hidden;
}

// /deep/ .el-carousel__indicators--outside {
//   bottom: 0;
//   position: absolute;
// }
/deep/ .el-carousel__indicators--horizontal {
  background: rgba(0, 0, 0, 0.5);
  height: 0.2rem;
  border-radius: 0.1rem;
  bottom: 0.1rem;
  line-height: 0.2rem;
}

/deep/ .el-carousel__indicator--horizontal {
  padding: 0rem 0.05rem;
}

/deep/ .el-carousel__indicator--horizontal .el-carousel__button {
  // opacity: 0.3;
  width: 0.1rem;
  height: 0.1rem;
  background: rgba(255, 255, 255, 0.8);

  border-radius: 50%;
  border: 1px solidrgba(255, 255, 255, 0.8);
  opacity: 1;
}

/deep/ .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 0.3rem;
  height: 0.1rem;
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 2rem;
}

.index_typeList>.el-carousel {
  width: 100%;
}

.index_typeList>img {
  width: 100%;
}

.el-menu--horizontal>.el-sub-menu.is-active {
  color: #c01a26 !important;
}

.el-sub-menu.is-active .el-sub-menu__title {
  border: 0rem solid #000;
}

/* .SL_classify_body, */
.SL_classify {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.SL_hotSongwriter {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 0.7rem;
  margin-bottom: 0.3rem;
}

.SL_hotSongwriter_title {
  font-size: 0.24rem;
  color: #000;
}

.SL_hotSongwriter_click {
  font-size: 0.14rem;
  color: #333;
}

.SL_offerMaterialList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.SL_offerMaterialListdiv {
  transition: all 0.5s;
  width: 3.02rem;
  height: 1.7rem;
  position: relative;
  margin-bottom: 0.3rem;
  display: block;
  border-radius: 15px;
}

/deep/ .SL_offerMaterialListView {
  position: static;
  border-radius: 15px;
}

.SL_newNeeddiv,
.SL_hotSongwriter_list {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 0.01rem solid #e5e6eb;
  padding-bottom: 0.16rem;
  margin-bottom: 0.16rem;
  width: 100%;
}

.SL_newNeeddiv:last-child {
  border-bottom: 0rem solid #e5e6eb;
}

.SL_CB_list {
  margin-bottom: 0.32rem;
}

.Particulars {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100vh);
  height: calc(100vh);
  /* min-height: calc(100vh); */
  background: rgba(0, 0, 0, 0.8);
}

.body_top {
  margin: 0 auto;
  position: relative;
}

.body_main {
  display: block;
  width: 12.8rem;
  // width: 70%;
  margin: 0 auto;
  overflow: hidden;
}

.bg_img_div {
  width: 100%;
  height: 7rem;
  position: relative;
  // z-index: -1;
  // background: rgba(0, 0, 0, 0.5);
  // overflow: hidden;
  background: url("../../assets/newIndexBg4.png") no-repeat bottom center;
  background-size: 100% 100%;
}

.bg_img_div>img {
  width: 100%;
  height: 100%;
  display: absolute;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  // background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));

  /* 50%为自身尺寸的一半 */
}

.body_top_abs {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}

.body_top_abs>.img_he {
  width: 100%;
  text-align: center;
  margin-top: 1.3rem;
}

.log_Img {
  text-align: center;
  width: 2.8rem;
}

.bt1 {
  margin-top: 0.1rem;
  color: #ffffff;
  font-size: 0.3rem;
  text-align: center;
}

.bt2 {
  margin-top: 0.08rem;
  font-size: 0.16rem;
  color: #ffffff;
  text-align: center;
}

.body_top_abs_gn {
  flex: 1;
  position: relative;
  width: 7.5rem;
  margin: 0 auto;
  margin-top: 0.8rem;
}

.ag_select {
  margin-bottom: 0.32rem;
  display: flex;
  justify-content: center;
}

.ag_select>span {
  margin-right: 0.24rem;
  font-size: 0.14rem;
  line-height: 0.16rem;
  padding-bottom: 0.03rem;
  border-radius: 1rem;
  padding: 0.1rem 0.2rem;
}

.ag_selectT {
  background: #fff;
  color: #333333;
}

.ag_selectF {
  background: rgba(0, 0, 0, 0.5);
  color: #ffffff;
}

.ag_selectF:hover {
  background: #fff;
  color: #333333;
}

.ag_l {
  width: 100%;
  display: flex;
  justify-content: initial;
  align-items: center;
}

.log_box {
  position: absolute;
  bottom: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  // align-items: center;
  width: 100%;

  img {
    // width: 1.2rem;
    height: 0.4rem;

    &:nth-of-type(2) {
      margin: 0 0.24rem;
    }
  }

  p {
    padding: 0 0.21rem;
    color: #fff;
  }
}

.ss_abs_c_srk {
  width: 8rem;
  display: flex;
  overflow: hidden;
  border-radius: 0.08rem;
}

.ss_abs_c_srk>input {
  flex-grow: 1;
  font-size: 0.14rem;
  border: 0rem solid #fff;
  padding: 0.16rem;
}

.ss_abs_c_srk>div {
  font-size: 0.14rem;
  color: #ffffff;
  background: #c01a26;
  padding: 0.16rem 0.24rem;
  display: flex;
  align-items: center;
}

.ss_abs_c_srk>div>img {
  width: 0.16rem;
  margin-right: 0.06rem;
}

.ss_abs_c_srk>div>input {
  border: 0rem solid #fff;
  background: #fff;
}

.wCB_select {
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  justify-content: flex-start;
  align-items: flex-start;
}

.wCB_select {
  justify-content: space-between;
}

.directionList {
  flex-wrap: wrap;
}

.directionTitle {
  margin-right: 0.4rem;
  border-radius: 1rem 0rem 1rem 1rem;
  background: #7f7f8c;
  font-size: 0.14rem;
  color: #ffffff;
  padding: 0.06rem 0.16rem;
  display: block;
  white-space: nowrap;
}

.directionList span {
  padding: 0.04rem 0.14rem;
  margin-right: 0.12rem;
  display: block;
  font-size: 0.14rem;
  color: #86909c;
  margin-bottom: 0.24rem;
}

.directionListY {
  background: rgba(255, 96, 0, 0.2);
  color: #c01a26 !important;
  border-radius: 1rem 1rem 1rem 1rem;
}

.worksClassifyBody {
  width: 100%;
}

.index_mk_body {
  display: flex;
  padding: 0.6rem 0;
  justify-content: space-between;
}

.index_mk_body>div {
  width: 3.5rem;
  display: flex;
}

.index_mk_body>div>img {
  width: 0.52rem;
  height: 0.52rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 0.1rem;
  margin-right: 0.24rem;
}

.index_mk_body1 {
  display: flex;
  justify-content: space-between;
  margin: 0.6rem 0;
}

.index_mk_body1>div {
  flex: none;
  width: 32%;
  height: 162px;
  border-radius: 8px;
  // background: #C01A26;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.24rem;
}

.index_mk_body1>div:nth-of-type(1) {
  background: url("../../assets/sybxmk4.png") no-repeat;
  background-size: 100% 100%;
}

.index_mk_body1>div:nth-of-type(2) {
  background: url("../../assets/sybxmk5.png") no-repeat;
  background-size: 100% 100%;
}

.index_mk_body1>div:nth-of-type(3) {
  background: url("../../assets/sybxmk6.png") no-repeat;
  background-size: 100% 100%;
}

.index_mk_body1>div p:nth-of-type(1) {
  font-size: 0.2rem;
}

.index_mk_body1>div p:nth-of-type(2) {
  font-size: 0.14rem;
  margin-top: 0.04rem;
  text-align: center;
}

.index_mk_right>span {
  color: #333333;
  font-weight: bold;
  font-size: 0.2rem;
  display: block;
}

.index_mk_right>div>span {
  display: block;

  font-size: 0.12rem;
  color: #86909c;
  font-weight: 400;
}

// .ss_abs_c_center {
// 	margin: 0 0.16rem;
// 	font-size: 0.14rem;
// 	color: #FFF;
// }

// .ss_abs_c_right {
// 	background: #C01A26;
// 	color: #FFF;
// 	padding: 0.16rem 0.24rem;
// 	border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
// 	font-size: 0.14rem;
// }
@media screen and (max-width: 750px) {
  body {
    font-size: 62.5%;
  }

  .body_top {
    width: 100vw;
  }

  .bg_img_div {
    // height: 30vh;
    background-size: cover;
  }

  .log_Img {
    width: 40vw;
  }

  .body_top_abs>.img_he {
    margin-top: 10vh;
  }

  .bt1 {
    margin-top: 1em;
    color: #ffffff;
    font-size: 1.8em;
    text-align: center;
  }

  .ag_select {
    display: none;
  }

  .ss_abs_c_srk {
    width: 95vw;
  }

  .ag_l {
    justify-content: center;
  }

  .body_top_abs_gn {
    width: 90%;
    margin-top: 3.5em;
  }

  .bg_img_div {
    height: 33em;
  }

  .log_box {
    width: 100%;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }

  .log_box img {
    width: 30%;
  }

  .index_mk_body {
    display: none;
  }

  /deep/ .el-carousel__container {
    height: 86px;
    border-radius: 0.12rem;
    overflow: hidden;
    margin-top: 2em;
  }

  /deep/ .el-carousel__indicators--horizontal {
    display: none;
  }

  .body_main {
    width: 90%;
  }

  .SL_hotSongwriter_title {
    font-size: 20px;
    font-weight: 550;
  }

  .SL_hotSongwriter {
    margin-top: 0.7em;
  }

  .SL_offerMaterialListdiv {
    transition: all 0.5s;
    position: relative;
    margin-bottom: 0.3rem;
    display: block;
    border-radius: 15px;
    width: 100%;
  }
}

.prompt {
  // width: 100%;
  // padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  // .prompt1 {
  //   height: 40px;
  //   width: 100%;
  //   background: #ffebb9;
  //   color: #e57b19;
  //   border-radius: 10px;
  //   font-size: 14px;
  //   display: flex;
  //   align-items: center;
  //   // justify-content: center;
  // }
}

.el-alert {
  margin-top: 20px;
  border-radius: 10px;

  .ml5 {
    margin-left: 5px;
  }
}

// .el-alert:first-child {
//   margin: 0;
// }
</style>
